import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import BillingHistoryTabTable from './BillingHistoryTabTable';

const BillingHistoryTab = () => {
  const [activeTab, setActiveTab] = useState('all');

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      {/* Top Tabs */}
      <Tabs
        value={activeTab}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{
          mb: 3,
          display: 'flex',
          alignItems: 'center',
          '& .MuiTabs-indicator': {
            display: 'none', // underline remove
          },
          '& .MuiTab-root': {
            textTransform: 'capitalize',
            fontWeight: 600,
            fontFamily: 'Manrope',
            fontSize: '14px',
            padding: '6px 24px',
            borderRadius: '50px',
            color: '#1A1A1A',
            minHeight: 'auto',
            border: '1px solid #ccc',
          },
          '& .MuiTab-root:not(:last-child)': {
            marginRight: '10px', // 👈 yaha se gap aayega
          },
          '& .Mui-selected': {
            background: '#0076FE',
            color: '#fff !important',
          },
        }}
      >
        <Tab label="All Invoices" value="all" />
        <Tab label="Paid" value="Paid" />
        <Tab label="Unpaid" value="Unpaid" />
      </Tabs>


      {/* Tab Content */}
      <BillingHistoryTabTable filter={activeTab} />
    </Box>
  );
};

export default BillingHistoryTab;
